
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"10.261","height":"11.894"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#6b7786","stroke-miterlimit":"10"}},[_c('path',{attrs:{"d":"M5.133 11.394a1.322 1.322 0 001.279-.99H3.855a1.322 1.322 0 001.278.99zM5.789 1.88v-.72a.66.66 0 10-1.321 0v.72"}}),_c('path',{attrs:{"d":"M9.696 9.874A7.034 7.034 0 018.429 6.2V5.122a3.3 3.3 0 00-6.6 0V6.2A7.043 7.043 0 01.562 9.876a.347.347 0 00.294.528h8.548a.34.34 0 00.3-.179h0a.339.339 0 00-.008-.351z"}})])])
          )
        }
      }
    